export * from "./useTrustPilotConfig";
